/* eslint-disable no-restricted-properties -- these tests need to use process.env */
import { describe, expect, it, beforeEach, afterEach } from '@jest/globals';
import { expandEnvironmentVariables } from './expandEnvironmentVariables.js';
import type { AppConfig } from '@ms-cloudpack/common-types';

describe('expandEnvironmentVariables', () => {
  const OriginalEnv = process.env;

  beforeEach(() => {
    process.env = { ...OriginalEnv };
  });

  afterEach(() => {
    process.env = OriginalEnv;
  });

  it('replaces {env:avett} with "I love the Avett Brothers!"', () => {
    process.env['avett'] = 'I love the Avett Brothers!';

    const config: AppConfig = {
      extends: 'someOtherConfig.json',
      server: {
        requestHeaders: {
          'X-AVETT': 'Do you know something? {env:avett} I really really do.',
        },
      },
    };

    expandEnvironmentVariables(config as Record<string, unknown>);
    expect(config.server?.requestHeaders?.['X-AVETT']).toBe(
      'Do you know something? I love the Avett Brothers! I really really do.',
    );
  });

  it('replaces all instances {env:_TAB_01} with "The-Avett-Brothers"', () => {
    process.env['_TAB_01'] = 'The-Avett-Brothers';

    const config: AppConfig = {
      server: {
        domain: 'www.headFullOfDoubt.com',
        port: [443, 8080],
        https: {
          key: '/root/{env:_TAB_01}/certs/key.key',
          cert: '/root/{env:_TAB_01}/certs/cert.cert',
          passphrase: '{env:_TAB_01}!!',
        },
      },
    };

    expandEnvironmentVariables(config as Record<string, unknown>);
    expect(config.server?.https).toEqual({
      key: '/root/The-Avett-Brothers/certs/key.key',
      cert: '/root/The-Avett-Brothers/certs/cert.cert',
      passphrase: 'The-Avett-Brothers!!',
    });
  });

  it('does not replace {sweptAway} because it is not preceded by env:', () => {
    process.env['sweptAway'] = 'I see the end of a rainbow, but what more is a rainbow than colors out of reach?';

    const config: AppConfig = {
      server: {
        domain: 'www.{sweptAway}.com',
      },
    };

    expandEnvironmentVariables(config as Record<string, unknown>);
    expect(config.server?.domain).toBe('www.{sweptAway}.com');
  });

  it('replaces {env:noHardFeelings} with empty string because if no such environment variable is set', () => {
    const config: AppConfig = {
      server: {
        domain: 'www.i-have-no-{env:noHardFeelings}-enemies.com',
      },
    };

    expandEnvironmentVariables(config as Record<string, unknown>);
    expect(config.server?.domain).toBe('www.i-have-no--enemies.com');
  });

  it('expands enviroment variables within arrays', () => {
    process.env = {
      surviving: 'Track-01-Surviving',
      criminalEnergy: 'Track-02-CriminalEnergy',
      delivery: 'Track-03-Delivery',
      fiveFiveFive: 'Track-04-555',
    };
    const config: AppConfig = {
      server: {
        domain: 'www.surviving.com',
      },
      routes: [
        { match: '/jimmy-eat-world/surviving/{env:surviving}.html' },
        { match: '/jimmy-eat-world/surviving/{env:criminalEnergy}.html' },
        { match: '/jimmy-eat-world/surviving/{env:delivery}.html' },
        { match: '/jimmy-eat-world/surviving/{env:fiveFiveFive}.html' },
      ],
    };

    expandEnvironmentVariables(config as Record<string, unknown>);
    expect(config.routes).toEqual([
      { match: '/jimmy-eat-world/surviving/Track-01-Surviving.html' },
      { match: '/jimmy-eat-world/surviving/Track-02-CriminalEnergy.html' },
      { match: '/jimmy-eat-world/surviving/Track-03-Delivery.html' },
      { match: '/jimmy-eat-world/surviving/Track-04-555.html' },
    ]);
  });
});
